const { render } = wp.element;

import ColorPalettes from "./Color-Palettes";

class ThemeSwitch {

  /**
   * Init
   */
  static init() {
    const THIS = new ThemeSwitch();
    THIS.injectSwitch();
  }

  // Inject the switch.
  injectSwitch = () => {
    if (!wp_dark_mode_admin_json.options.admin_enabled_block_editor ) return;

    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(ThemeSwitch.appendThemeSwitch, 500);
    });



  }


  // Append the switch.
  static appendThemeSwitch = () => {
    const is_saved = localStorage.getItem("wp_dark_mode_gb");

    if (!!is_saved) {
      document
        .querySelector("html")
        .classList.add(`wp-dark-mode-theme-${is_saved}`);
    }

    let node = document.querySelector(".edit-post-header__toolbar");

    if (!node) {
      node = document.querySelector(
        ".edit-widgets-header__navigable-toolbar-wrapper"
      );
    }

    let newElem = document.createElement("div");
    newElem.classList.add("wpdm-theme-switch-wrapper");
    // Log("node", newElem);

    let html = `<div id="wpDarkModeThemeSwitch"><img id="wpDarkModeThemeSwitchImg" src="${wp_dark_mode_admin_json.paths.plugin}/includes/modules/gutenberg/images/default.png" /> <i class="wpdm-arrow down"></i> </div>`;
    html += `<div id="wpdmColorPalettesContainer"></div> `;

    newElem.innerHTML = html;

    if (!node) return;

    node.insertBefore(newElem, node.childNodes[1]);

    document
      .getElementById("wpDarkModeThemeSwitch")
      .addEventListener("click", ThemeSwitch.editorColorPalettes);

    // On click outside.
    document.addEventListener("click", function (e) {
      if (
        !document.getElementById("wpdmColorPalettesContainer") ||
        !document.getElementById("wpDarkModeThemeSwitch")
      )
        return;

      if (
        !document.getElementById("wpdmColorPalettesContainer").contains(e.target) &&
        !document.getElementById("wpDarkModeThemeSwitch").contains(e.target)
      ) {
        window.themeChooseActive = false;
        render(
          <ColorPalettes active={window.themeChooseActive} />,
          document.getElementById("wpdmColorPalettesContainer")
        );
      }
    });

    // on press escape.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        window.themeChooseActive = false;
        render(
          <ColorPalettes active={window.themeChooseActive} />,
          document.getElementById("wpdmColorPalettesContainer")
        );
      }
    });
  }

  // Editor color palettes.
  static editorColorPalettes() {
    window.themeChooseActive = !window.themeChooseActive;
    render(
      <ColorPalettes active={window.themeChooseActive} />,
      document.getElementById("wpdmColorPalettesContainer")
    );
  }

}

// Init
ThemeSwitch.init();


